import { A3MM, A4MM, BasePDFNode, getYoga, RectPDFNode, TextPDFNode } from "./BasePDFNode";
import jsPDF from "jspdf";
import { ModBusIn, ModBusOut, RangedKanaalAssign } from "../props/PropTypes";
import { PageCardNode } from "./PageCardNode";
import { TranslateService } from "../i18n/translate.service";
export class ModbusPDFNode extends BasePDFNode {
    constructor(pdf: jsPDF, public translateService: TranslateService,  public assign: RangedKanaalAssign[], private modbusNetworks: {index: number, label: string}[], public pageCard: PageCardNode | undefined) {
        super(pdf, {
            flexDirection: 'column',
            flexGrow: 1,
            margin: 2,
            padding: 2,

        }, getYoga().Node.create());
    }

    public init(): void {

        let assign = this.assign.filter(a => a.rangedKnaal.ioType.equals(ModBusOut)).sort((a,b) => a.rangedKnaal.start - b.rangedKnaal.start);
        let assignOut:  RangedKanaalAssign[][] = [];
        let labels: string[] = [];
        if (assign.length > 0) {
            for (let i = 0; i < assign.length; i += 80) {
                let tmAssign = assign.slice(i, i+80)
                assignOut.push(tmAssign);
                labels.push("Out");
                if (assignOut.length == 2) {
                    this.addChild2(new ModbusPDFNodePage(this.pdf, this.translateService, assignOut, labels, this.modbusNetworks, this.pageCard));
                    assignOut = [];
                    labels = [];
                }
            }

        }


        assign = this.assign.filter(a => a.rangedKnaal.ioType.equals(ModBusIn)).sort((a,b) => a.rangedKnaal.start - b.rangedKnaal.start);
        if (assign.length > 0) {
            for (let i = 0; i < assign.length; i += 80) {
                let tmAssign = assign.slice(i, i+80)
                assignOut.push(tmAssign);
                labels.push("In");
                if (assignOut.length == 2) {
                    this.addChild2(new ModbusPDFNodePage(this.pdf, this.translateService, assignOut, labels, this.modbusNetworks, this.pageCard));
                    assignOut = [];
                    labels = [];
                }
            }

        }
        if (assignOut.length > 0) {
            this.addChild2(new ModbusPDFNodePage(this.pdf, this.translateService, assignOut, labels, this.modbusNetworks, this.pageCard));
        }

        super.init();

    }



    public render(): void {
        super.render();
    }

}

export class ModbusPDFNodePage extends BasePDFNode {
    constructor(pdf: jsPDF, public translateService: TranslateService,  public assign: RangedKanaalAssign[][], public labels: string[],private modbusNetworks: {index: number, label: string}[],  public pageCard: PageCardNode | undefined) {
        super(pdf, {
            flexDirection: 'column',
            flexGrow: 1,
            margin: 2,
            padding: 2,

        }, getYoga().Node.create());
    }

    private addModbus(base: BasePDFNode, assign: RangedKanaalAssign[]): void {
        let repo = this.translateService.translateSignal();

        let iocontainer = base.addChild2(new RectPDFNode(this.pdf, {
            flexDirection: 'column',
            rowGap: 2,
            maxWidth: 135,
            padding:2
            // fillColor: '#E0E000',
            // borderColor: '#E00000'

        }));

        let row = iocontainer.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'row',
            columnGap: 2
        }));
        row.addChild2(new TextPDFNode(this.pdf, {
            textWeight: "bold",
            width: 12
        })).text = this.translateService.getTranslationSync(repo, 'pdf', 'Adres', 'Adres'); //"Adres";
        row.addChild2(new TextPDFNode(this.pdf, {
            textWeight: "bold",
            width: 36
        })).text = this.translateService.getTranslationSync(repo, 'pdf', 'Netwerk', 'Netwerk'); // "Netwerk";
        row.addChild2(new TextPDFNode(this.pdf, {
            textWeight: "bold",
            width: 20
        })).text = this.translateService.getTranslationSync(repo, 'pdf', 'Afdeling', 'Afdeling'); // "Afdeling";
        row.addChild2(new TextPDFNode(this.pdf, {
            textWeight: "bold",
            width: 77
        })).text = this.translateService.getTranslationSync(repo, 'pdf', 'Beschrijving', 'Beschrijving'); // "Beschrijving";

        for (let a of assign) {
            let row = iocontainer.addChild2(new BasePDFNode(this.pdf, {
                flexDirection: 'row',
                columnGap: 2
            }));
            let kanalLabel = `${a.rangedKnaal.start}`;
            if (a.rangedKnaal.range > 1) {
                kanalLabel = `${a.rangedKnaal.start} - ${a.rangedKnaal.start + a.rangedKnaal.range - 1}`;
            }
            row.addChild2(new TextPDFNode(this.pdf, {
                width: 12
            })).text = kanalLabel;
            let nLabel = "";
            if (a.rangedKnaal.network != undefined) {
                let network = this.modbusNetworks.find(n => n.index == a.rangedKnaal.network);
                nLabel = `${network?.label}`;
            }
            row.addChild2(new TextPDFNode(this.pdf, {
                width: 36
            })).text = nLabel;
            row.addChild2(new TextPDFNode(this.pdf, {
                width: 20
            })).text = `${a.assignement.afdeling}`;
            row.addChild2(new TextPDFNode(this.pdf, {
                width: 77
            })).text = `${a.assignement.type} ${a.assignement.omschrijving}`;
            // for (let k = a.rangedKnaal.start; k < a.rangedKnaal.start + a.rangedKnaal.range; k++) {

            // }
        }
    }

    public init(): void {
        let txt = this.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 12,
            marginBottom: 2
        }));
        txt.text = 'ModBus';
        let c1 = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'row',
            justifyContent: "space-between"
        }));

        let leftC = c1.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'column',
            flexGrow: 1,
            rowGap:2
        }));
        leftC.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 12,
        })).text = this.labels[0];
        this.addModbus(leftC, this.assign[0]);
        if (this.labels.length > 1) {
            let rightC = c1.addChild2(new BasePDFNode(this.pdf, {
                flexDirection: 'column',
                flexGrow: 1,
                rowGap:2
            }));
            rightC.addChild2(new TextPDFNode(this.pdf, {
                fontSize: 12,
            })).text = this.labels[1];
            this.addModbus(rightC, this.assign[1]);
        }
    }

    public render(): void {
        this.pdf.addPage("a3", "p");
        // this.layout.calculateLayout(A3MM.height, A3MM.width);
        this.layout.calculateLayout(A3MM.width, A3MM.height);

        if (this.pageCard == undefined) {
            let l = this.layout.getComputedLayout();
            let topLeft = this.getTopLeft();
            this.pdf.rect(topLeft.x, topLeft.y, l.width, l.height);
        } else {
            this.pageCard.render();
        }

        super.render();
    }

}
